import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";

export default function BannerOtimizeNegocio({
    headingBold,
    headingText,
    buttonText,
    buttonUrl = "#",
}) {
    const { openModal } = useModal();
    return (
        <div className="bg-[rgb(168,0,228)] bg-[url(../assets/banner-otimize.png)] bg-no-repeat bg-cover bg-center text-white py-24 px-30">
            <div className="container mx-auto">
                <section className="max-w-[512px] w-full ms-auto space-y-8">
                    <h2 className="font-light text-[40px]">
                        <strong className="font-bold">{headingBold}</strong>
                        {headingText}
                    </h2>
                    <button
                        onClick={() => openModal(<FormularioRD />)}
                        className="rounded-full bg-white text-[#A800E4] py-2 px-9 w-fit text-xl font-bold hover:scale-105 transition-all duration-300 cursor-pointer inline-block"
                    >
                        {buttonText}
                    </button>
                </section>
            </div>
        </div>
    );
}
